import styled, { css } from 'styled-components';
const Jumbo = styled.span `
    font-family: ${({ theme }) => theme.typography.font.family.sansSerif};
    font-size: ${({ theme }) => theme.typography.textStyles.jumbo.fontSize};
`;
const Big = styled.span `
    font-family: ${({ theme }) => theme.typography.font.family.sansSerif};
    font-size: ${({ theme }) => theme.typography.textStyles.big.fontSize};
`;
const Normal = styled.span `
    font-family: ${({ theme }) => theme.typography.font.family.sansSerif};
    font-size: ${({ theme }) => theme.typography.textStyles.normal.fontSize};
`;
const Small = styled.span `
    font-family: ${({ theme }) => theme.typography.font.family.sansSerif};
    font-size: ${({ theme }) => theme.typography.textStyles.small.fontSize};
`;
const Micro = styled.span `
    font-family: ${({ theme }) => theme.typography.font.family.sansSerif};
    font-size: ${({ theme }) => theme.typography.textStyles.micro.fontSize};
`;
const Notification = styled.span `
    font-family: ${({ theme }) => theme.typography.font.family.sansSerif};
    font-size: ${({ theme }) => theme.typography.textStyles.notification.fontSize};
`;
const Quote = styled.span `
    font-family: ${({ theme }) => theme.typography.font.family.serif};
    font-size: ${({ theme }) => theme.typography.textStyles.quote.fontSize};
`;
const Author = styled.span `
    font-family: ${({ theme }) => theme.typography.font.family.serif};
    font-size: ${({ theme }) => theme.typography.textStyles.author.fontSize};
`;
const baseCodeStyles = (_) => css `
    font-family: ${({ theme }) => theme.typography.font.family.code};
    font-size: ${({ theme }) => theme.typography.textStyles.code.fontSize};
    background-color: ${({ theme, variant }) => {
    return variant === 'dark'
        ? theme.typography.textStyles.code.contrastBackgroundColor.toString()
        : 'transparent';
}};
    color: ${({ theme, variant }) => {
    return variant === 'dark'
        ? theme.typography.textStyles.code.contrastColor.toString()
        : 'auto';
}};
`;
const Code = styled.pre `
    ${baseCodeStyles}

    padding: ${({ theme }) => theme.typography.textStyles.code.padding.toString()};
`;
const InlineCode = styled.code `
    ${baseCodeStyles}

    display: inline-block;
    padding: 0 ${({ theme }) => theme.spacing.xxs.toString()};
    margin: 0 ${({ theme }) => theme.spacing.xxs.toString()};
`;
export const textStyles = {
    Jumbo,
    Big,
    Normal,
    Small,
    Micro,
    Notification,
    Quote,
    Author,
    Code,
    InlineCode,
};
//# sourceMappingURL=textStyles.js.map